import {
  Button,
  Div,
  H3,
  Icon,
  Img,
  P,
  PlusIcon,
  noModifierGroups,
} from '@vgrubs/components';
import {
  MenuV2Response,
  ModifierGroupItemV2Response,
} from 'components/src/types/menu.types';
import { Dispatch, SetStateAction, useState } from 'react';
import { AddNewModifierGroupModal } from './AddNewModifierGroupModal';
import { DeleteModifierModal } from './DeleteModifierModal';
import { ModifierGroupComponent } from './ModifierComponents';

export const Modifiers = ({
  menu,
  setMenu,
  setLoading,
}: {
  menu: MenuV2Response | null;
  setMenu: Dispatch<SetStateAction<MenuV2Response | null>>;
  setLoading: Dispatch<SetStateAction<boolean>>;
}) => {
  const [addNewModal, setAddNewModal] = useState(false);
  const [editModal, setEditModal] =
    useState<ModifierGroupItemV2Response | null>(null);
  const [deleteModal, setDeleteModal] = useState<number | null>(null);

  async function handleDeleteItem() {
    setMenu((prev) => {
      if (!prev) return prev;
      const updated = prev.modifierGroups.filter(
        (item) => item.id !== deleteModal
      );

      return { ...prev, modifierGroups: updated };
    });

    setDeleteModal(null);
  }

  const AddModifierGroupButton = () => {
    return (
      <Button $wSM="200px" $selected onClick={() => setAddNewModal(true)}>
        Add Modifier Group
      </Button>
    );
  };

  return (
    <Div>
      <Div $flex $between $alignCenter $mb="20">
        <H3 $mb="0">
          {menu?.modifierGroups && menu?.modifierGroups?.length < 1
            ? 'Modifier Group'
            : 'Modifier Groups'}{' '}
          ({menu?.modifierGroups?.length})
        </H3>

        {menu?.modifierGroups && menu?.modifierGroups?.length > 0 && (
          <Icon $pointer onClick={() => setAddNewModal(true)}>
            <PlusIcon />
          </Icon>
        )}
      </Div>

      {menu?.modifierGroups?.map((item, i) => (
        <ModifierGroupComponent
          key={i}
          item={item}
          onClickDelete={(id) => setDeleteModal(id)}
          onClick={(item) => setEditModal(item)}
        />
      ))}

      {menu?.modifierGroups && menu?.modifierGroups?.length < 1 && (
        <Div $flex $column $alignCenter>
          <Img alt="" $width="180px" src={noModifierGroups} $mb="24" />
          <H3 $mb="24" $center>
            No Modifier Groups
          </H3>
          <P $mb="32" $center>
            This provider currently don’t have <br /> menu modifier groups.
          </P>
          <AddModifierGroupButton />
        </Div>
      )}

      <AddNewModifierGroupModal
        addNewModal={addNewModal}
        closeModal={() => {
          setAddNewModal(false);
        }}
        setMenu={setMenu}
        setLoading={setLoading}
      />

      <AddNewModifierGroupModal
        addNewModal={editModal}
        closeModal={() => {
          setEditModal(null);
        }}
        setMenu={setMenu}
        setLoading={setLoading}
        edit
      />

      <DeleteModifierModal
        deleteModal={!!deleteModal}
        closeModal={() => {
          setDeleteModal(null);
        }}
        handleDeleteItem={handleDeleteItem}
      />
    </Div>
  );
};
